import { render } from "./DetailBlog.vue?vue&type=template&id=8b273b7c"
import script from "./DetailBlog.vue?vue&type=script&lang=js"
export * from "./DetailBlog.vue?vue&type=script&lang=js"

import "./DetailBlog.vue?vue&type=style&index=0&id=8b273b7c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__